var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis",style:({ left: _vm.left })},[_c('div',{style:({ 'background-color': _vm.color })}),_c('div',{style:({ 'background-color': _vm.color })}),_c('div',{style:({ 'background-color': _vm.color })}),_c('div',{style:({ 'background-color': _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }